import React, { useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps, useHistory, useLocation } from "react-router-dom";
import { translation } from "../../../../i18n/translationConstant";
import { SignupOtpInitiateRequest } from "../../../../Models/Request/Authentication/Signup";
import { UserLoginSuccessResponse } from "../../../../Models/Response/Authentication/Otp";
import {
  signupOtp,
  signupVerification,
  signupVerificationWithFingerPrint,
} from "../../../../Services/AuthenticationServices/AuthenticationServices";
import { setCredentialsLocalStorage } from "../../../../Services/LocalStorageServices";
import { QueryParams, Routes } from "../../../../Utils/Constants/routes";
import { vuaIdSuffix } from "../../../../Utils/Constants/vuaIdSuffix";
import FeedbackModal from "../../../Common/Components/FeedbackModal";
import OTPInputComponent from "../../../Common/Components/OTPModal";
import LoginSignupForm from "../Form";
import LoginSignupSidePanel from "../Greetings";
import "./index.css";
import WebviewOTPInputComponent from "../../../Common/Components/OTPModal/WebviewOTPInputComponent";


interface ISignupComponentProps extends WithTranslation, RouteComponentProps {}

const SignupComponent: React.FC<ISignupComponentProps> = ({
  location,
  history,
  t,
}) => {
  const { push } = useHistory();
  const [current, setCurrent] = useState(0);
  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [otpUniqueID, setOTPUniqueId] = useState("");
  const [signUpDTO, setSignUpDTO] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    pin: "",
    vuaId: "" + vuaIdSuffix.value,
  });
  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const query: any = useQuery();
  const redirect: any = location.state;

  const state: any = history.location.state;

  const verify = (values: SignupOtpInitiateRequest) => {
    if (values.vuaId.indexOf(vuaIdSuffix.value) === -1) {
      values = { ...values, vuaId: values.vuaId + vuaIdSuffix.value };
    }
    setSignUpDTO(values);
    signupOtp(values)
      .then((res) => res.data)
      .then((res) => {
        setIsOTPModalVisible(true);
        setOTPUniqueId(res.otpUniqueID);
      });
  };

  const closeModal = () => {
    setIsOTPModalVisible(false);
  };

  const signUpRedirect = () => {
    setTimeout(() => {
      if (query && query.get(QueryParams.redirect)) {
        history.push(query.get(QueryParams.redirect) + (state.search ?? ""));
      } else {
        history.push(Routes.linkAccounts);
      }
    }, 3000);
  };

  const onSignupVerificationOtp = (otp: string) => {
    // signupVerification({
    signupVerificationWithFingerPrint({
      otp,
      vuaId: signUpDTO.vuaId,
      pin: signUpDTO.pin,
      otpUniqueID,
    })
      .then((res) => res.data)
      .then((res: UserLoginSuccessResponse) => {
        setCurrent(current + 1);

        setCredentialsLocalStorage(res);
        setIsOTPModalVisible(false);
        signUpRedirect();
      });
  };

  const logIn = () => {
    push(Routes.login);
  };

  const modalClose = () => {
    push(Routes.linkAccounts);
  };

  const action = () => {
    push(Routes.linkAccounts);
  };

    
  // useEffect(() => {
  //   if (redirect?.phoneNumber) {

  //     const generatedPin = Math.floor(100000 + Math.random() * 900000).toString(); // random 6-digit PIN
      
  //     const prefilledValues = {
  //       firstName: "User", 
  //       lastName: "lName", 
  //       phoneNumber: redirect.phoneNumber,
  //       pin: generatedPin,
  //       vuaId: redirect.phoneNumber + vuaIdSuffix.value, 
  //     };
  //     setSignUpDTO(prefilledValues);

  //     // Trigger OTP automatically
  //     signupOtp(prefilledValues)
  //       .then((res) => res.data)
  //       .then((res) => {
  //         setOTPUniqueId(res.otpUniqueID);
  //       });
  //   }
  // }, [redirect]);


  return (
    <>
      {current === 1 ? (
        <FeedbackModal
          modalClose={modalClose}
          message={"Your account has been successfully created."}
          action={action}
          actionButtonText={t(translation.lblLetsGetStarted)}
        />
      ) : (
        <></>
      )}
      <OTPInputComponent
        onCancel={closeModal}
        isOpen={isOTPModalVisible}
        onOtpSubmit={onSignupVerificationOtp}
        okText={t(translation.lblConfirm)}
        title={t(translation.lblCreateAccount)}
        // tslint:disable-next-line: jsx-no-lambda
        onResend={() => verify(signUpDTO)}
        mobileNumber={signUpDTO.phoneNumber}
      />
      <div className="signupRoot">
        <div className="sliderCss sliderCssBorder1">
          
            {(redirect?.phoneNumber) ?
            <>
              <LoginSignupSidePanel type="webview" />
              {/* <WebviewOTPInputComponent
                isOpen={true}
                onOtpSubmit={onSignupVerificationOtp}
                okText={t(translation.lblConfirm)}
                title={t(translation.lblEnterOTP)}
                // onResend={() => verify(signUpDTO)}
                onResend={() => {
                  signupOtp(signUpDTO)
                  .then((res) => res.data)
                  .then((res) => {
                    setOTPUniqueId(res.otpUniqueID);
                  });
                }}        
                mobileNumber={signUpDTO.phoneNumber}
              /> */}
              <div className="signForm flexCustomCss">
                  <LoginSignupForm
                    className={"signFormTitle"}
                    formType={"Create Account"}
                    phoneNumber={!!redirect && redirect.phoneNumber}
                    isVuaIdDisabled={!!redirect && redirect.isVuaIdDisabled}
                    buttonSubSectionText={t(translation.lblAlreadyHaveAccount)}
                    buttonSubSectionButton={t(translation.lblLogin)}
                    formSubmit={verify}
                    subButtonClick={logIn}
                    buttonText={t(translation.lblNext)}
                  />
                </div>
            </>
            :
              <>
                <LoginSignupSidePanel type="signup" />
                <div className="signForm flexCustomCss">
                  <LoginSignupForm
                    className={"signFormTitle"}
                    formType={"Create Account"}
                    phoneNumber={!!redirect && redirect.phoneNumber}
                    isVuaIdDisabled={!!redirect && redirect.isVuaIdDisabled}
                    buttonSubSectionText={t(translation.lblAlreadyHaveAccount)}
                    buttonSubSectionButton={t(translation.lblLogin)}
                    formSubmit={verify}
                    subButtonClick={logIn}
                    buttonText={t(translation.lblNext)}
                  />
                </div>
              </>
            }
        </div>
      </div>
    </>
  );
};

export default withTranslation()(SignupComponent);
